import { PercentBoxIcon } from './PercentBoxIcon';

/**
 * author: Colton Wiscombe
 * id DD3C1F53-8265-4133-8C96-BC9EFF0A30D5
 * name percent-box
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/percent-box.svg
 * tags
 * - Math 
 * - Shopping 
 */
export const DiscountBoxIcon = PercentBoxIcon;
export default DiscountBoxIcon